import React, { useEffect, useState, useRef } from 'react';
import icone from '../../assets/images/info.png';
import icone2 from '../../assets/images/coeur.png';
import Img from '../../assets/images/c4.png';
import { useLocation, useNavigate } from "react-router-dom";
import {
  CButton,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CTab,
  CTabContent,
  CTabList,
  CTabPanel,
  CTabs,
  CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow
} from '@coreui/react'
import { FaRedoAlt, FaExchangeAlt, FaFilter, FaSearch, FaDownload, FaFolderOpen, FaEllipsisV, FaEdit } from "react-icons/fa";
import api from '../../service/caller';
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsArrowUpLeft, BsArrowDownUp } from 'react-icons/bs';
import Adminprofil from '../../assets/images/adminprofil.png';
import { ToastContainer, toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Table } from 'react-bootstrap';
import Formulaire from './form';
import AddRoomForm from './addroom';
import AddbedForm from './addbed';


const Rooms = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('unassigned'); // Default "unassigned"
  const [showaddroom, setAddroomShow] = useState(false);
  const [showaddbed, setAddbedShow] = useState(false);
  const [UserData, setUserData] = useState([]);
  const [rooms, setRooms] = useState([]); // State for fetched rooms
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);

  // Adding a state for selected room
  const [selectedRoom, setSelectedRoom] = useState(null); // This will store the selected room

  const handlePrescriptionClose = () => setShowPrescriptionModal(false);
  const handlePrescriptionShow = () => setShowPrescriptionModal(true);

  const handleAddroomClose = () => setAddroomShow(false);
  const handleAddroomShow = () => setAddroomShow(true);

  const handleAddbedClose = () => setAddbedShow(false);
  const handleAddbedShow = () => setAddbedShow(true);

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
  }, []);

  useEffect(() => {
    const fetchRooms = async () => {
      if (UserData && UserData.hospital_id && UserData.hospital_id._id) {
        try {
          let hospitalId = UserData.hospital_id._id;
          const response = await api.get(`/api/getrooms/${hospitalId}`);
          setRooms(response.data); // Set rooms to state
        } catch (error) {
          console.log("Error fetching rooms:", error);
          toast.error("Failed to fetch rooms data");
        }
      }
    };

    if (UserData && UserData.hospital_id) {
      fetchRooms();
    }
  }, [UserData]);

  // Handle room assignment
  const handleAssignPatient = (room) => {
    setSelectedRoom(room);  // Set the selected room when a user clicks on a room to assign
    setShowPrescriptionModal(true);  // Show the prescription modal
  };

  // modal
  const [show, setShow] = useState(false);
  const [shows, setShows] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCloses = () => setShows(false);
  const handleShows = () => setShows(true);

  return (
    <div className="py-4">
      <CHeader position="sticky" style={{ backgroundColor: '#DFEAF5' }}>
        <CContainer fluid className="d-flex align-items-center">
          <div className='row w-100'>
            {/* Barre de recherche */}
            <div className="pagetittle col">
              <h4><b>Room Management</b></h4>
              <p>Home <BsChevronRight className='mx-2' style={{ fontSize: "12px" }} />  Dashboard <BsChevronRight style={{ fontSize: "12px" }} className='mx-2' />  <span style={{ color: '#191B1C' }}>Room Management</span></p>
            </div>
            {/* Profil utilisateur */}

            <div className=' d-flex col justify-content-end'>
              <CHeaderNav>
                <CNavItem>
                  <CNavLink href="#" className="d-flex ms-auto">
                    <img src={Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                    <div>
                      <span className="ms-2" style={{ color: 'black' }} >{UserData.firstname} {UserData.lastname}</span>
                      <p className="ms-2" style={{ color: 'black' }} >{UserData.role?.name}</p>
                    </div>
                  </CNavLink>
                </CNavItem>
              </CHeaderNav>
            </div>
          </div>
        </CContainer>
      </CHeader>

      <div>
        <CRow>
          <CCol xs={12}>
            <CCard className="card mb-4 p-4">
              <CCardBody>
                <CTabs activeItemKey="room">
                  <CTabList variant="underline" className='border-bottom mx-auto'>
                    <CTab itemKey="room">Room Managment</CTab>
                    <CTab itemKey="bed">Bed Management</CTab>
                  </CTabList>
                  <CTabContent>
                    <CTabPanel className="" itemKey="room">
                      <div className="bg-body mt-4">
                        <div className="">
                          <div className='d-flex justify-content-center p-2 mb-5 Patientlist'>
                            <div className='p-2 d-flex justify-content-between' style={{ borderRadius: '25px', backgroundColor: "#0056B329", width: "30%" }}>
                              <button
                                className={`btn me-2 ${activeTab === 'assigned' ? 'text-light' : 'text-dark'}`}
                                style={{ borderRadius: '25px', backgroundColor: activeTab === 'assigned' ? "#28A745" : "", width: "50%" }}
                                onClick={() => setActiveTab('assigned')}
                              >
                                Assigned
                              </button>

                              <button
                                className={`btn ${activeTab === 'unassigned' ? 'text-light' : 'text-dark'}`}
                                style={{ borderRadius: '25px', backgroundColor: activeTab === 'unassigned' ? "#28A745" : "", width: "50%" }}
                                onClick={() => setActiveTab('unassigned')}
                              >
                                Unassigned
                              </button>
                            </div>
                            <div className='registeruserbtn ms-auto'>
                              <Button
                                className="registernewbtn ms-auto d-flex align-items-center"
                                onClick={handleAddroomShow} // Ouvre le modal
                              >
                                <BsPersonPlus className="mx-2" /> Add Room
                              </Button>

                              {/* Modal pour ajouter une chambre */}
                              <Modal show={showaddroom} onHide={handleAddroomClose} centered>
                                <Modal.Header className="w-100 d-flex justify-content-center">
                                  <Modal.Title>Add New Room</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  {/* Passer la fonction onClose au formulaire */}
                                  <AddRoomForm onClose={handleAddroomClose} />
                                </Modal.Body>
                                <Modal.Footer className="w-100 d-flex justify-content-center">
                                  <Button
                                    style={{ width: '60%', background: '#28A745', borderColor: '#28A745', padding: '12px 0' }}
                                    onClick={handleAddroomClose} // Ferme le modal
                                  >
                                    Close
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            </div>
                          </div>
                          <div className="row mb-5 justify-content-center">
                            <div className="col" style={{ borderRadius: '15px' }}>
                              <div className="input-group" style={{ borderRadius: '25px 0px 0px 25px', height: "50px" }}>
                                <span className="input-group-text border-none d-flex justify-content-end align-items-center ml-4" style={{ borderRadius: '25px 0px 0px 25px', backgroundColor: "#DFEAF5", width: '10%' }}>
                                  <img className='ml-5' src='/search-status.png' />
                                </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search for a patient(Enter ID, name or Tel)"
                                  style={{ borderRadius: '0px 25px 25px 0px', backgroundColor: "#0056B329" }}
                                />
                              </div>
                            </div>
                          </div>

                          {activeTab === 'assigned' ? (
                            <table className="table">
                              <thead className="thead-light">
                                <tr>
                                  <th className="text-dark pt-3" scope="col">Room No</th>
                                  <th className="text-dark" scope="col">Room Type</th>
                                  <th className="text-dark" scope="col">Occupied Beds</th>
                                  <th className='text-dark text-center' scope="col">Bed Assigns</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rooms
                                  .filter(room => room.beds.some(bed => bed.isOccupied))  // Filtrer pour afficher les chambres avec au moins un lit occupé
                                  .map((room, index) => (
                                    <tr key={index}>
                                      <td>{room.roomNumber}</td>
                                      <td>{room.type}</td>
                                      <td>
                                        {/* Affichez le nombre de lits occupés dans la chambre */}
                                        {room.beds.filter(bed => bed.isOccupied).length} / {room.beds.length} Beds Occupied
                                      </td>
                                      <td className='d-flex justify-content-center align-items-center'>
                                        <button
                                          className="btn me-2 text-light d-flex align-items-center"
                                          style={{
                                            borderRadius: '25px',
                                            backgroundColor: "#28A745",
                                            width: '80%',  // Largeur maximale (occupe toute la largeur de la cellule)
                                            padding: '12px 0',  // Ajuster la hauteur du bouton pour plus de visibilité
                                          }}
                                          onClick={handleShow}
                                        >
                                          <img src="/user-octagon.png" alt="Assign Icon" className="me-2" style={{ width: "20px", height: "20px" }} />
                                          <span>Assign</span>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          ) : (
                            <table className="table">
                              <thead className="thead-light">
                                <tr>
                                  <th className="text-dark  pt-3" scope="col">Room No</th>
                                  <th className="text-dark " scope="col">Room Type</th>
                                  <th className="text-dark " scope="col">Available Beds</th>
                                  <th className='text-dark text-center' scope="col">Bed Assigns</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rooms
                                  .filter(room => room.beds.every(bed => !bed.isOccupied))  // Filtrer pour afficher uniquement les chambres avec tous les lits libres
                                  .map((room, index) => (
                                    <tr key={index}>
                                      <td>{room.roomNumber}</td>
                                      <td>{room.type}</td>
                                      <td>
                                        {/* Affichez le nombre de lits libres dans la chambre */}
                                        {room.beds.filter(bed => !bed.isOccupied).length} / {room.beds.length} Beds Available
                                      </td>
                                      <td className='d-flex justify-content-center align-items-center'>
                                        <button
                                          className="btn text-light d-flex align-items-center justify-content-center"
                                          style={{
                                            borderRadius: '25px',
                                            backgroundColor: "#28A745",
                                            width: '80%',  // Largeur maximale (occupe toute la largeur de la cellule)
                                            padding: '12px 0',  // Ajuster la hauteur du bouton pour plus de visibilité
                                          }}
                                          onClick={() => handleAssignPatient(room)}
                                        >
                                          <img src="/user-octagon.png" alt="Assign Icon" className="me-2" style={{ width: "20px", height: "20px" }} />
                                          <span>Assign</span>
                                        </button>
                                      </td>

                                      <Modal show={showPrescriptionModal} onHide={handlePrescriptionClose} centered>
                                        <Modal.Header closeButton>
                                          <Modal.Title>Assign Prescription</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                          {/* Passez selectedRoom à Formulaire pour pré-remplir le champ */}
                                          <Formulaire roomId={selectedRoom?.roomNumber} onAssign={handleAssignPatient} />
                                        </Modal.Body>
                                        <Modal.Footer>
                                          <Button variant="secondary" onClick={handlePrescriptionClose}>
                                            Close
                                          </Button>
                                        </Modal.Footer>
                                      </Modal>


                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          )}

                        </div>
                      </div>
                    </CTabPanel>
                    <CTabPanel className="" itemKey="bed">
                    </CTabPanel>
                  </CTabContent>
                </CTabs>
                {/* paginate */}
                <div className='paginate me-5'>
                  <p className='mt-3'>
                    Showing
                  </p>
                  <div className='actionbtn'>
                    <div className='left'>
                      <BsChevronLeft className='pagicon' />
                    </div>
                    <div className='right'>
                      <BsChevronRight className='pagicon' />
                    </div>
                  </div>
                </div>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </div>
    </div>
  );
};

export default Rooms;
